module.exports = __webpack_public_path__ + "static/media/megamanvszero.37b38342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/megamanvszero.jpg
// module id = 91
// module chunks = 0